<template>
    <div id="app">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <a class="navbar-brand" href="javascript:;">SML Toolkit</a>
            <span class="text-secondary">{{ project.name }}</span>
        </nav>

        <div id="container">
            <div id="nav">
                <ul class="nav-pills list-unstyled">
                    <li><router-link to="/" class="nav-link" exact-active-class="active"><fa-icon icon="project-diagram" /> Projects</router-link></li>
                    <li><router-link v-if="isProjectLoaded" to="/features" class="nav-link" exact-active-class="active">Features</router-link><a v-else class="nav-link">Features</a></li>
                    <li><router-link v-if="isProjectLoaded" to="/static-diagram" class="nav-link" exact-active-class="active">Static</router-link><a v-else class="nav-link">Static</a></li>
                    <li><router-link v-if="isProjectLoaded" to="/dynamic-diagram" class="nav-link" exact-active-class="active">Dynamic</router-link><a v-else class="nav-link">Dynamic</a></li>
                    <li><router-link v-if="isProjectLoaded" to="/tasks" class="nav-link" exact-active-class="active">Tasks</router-link><a v-else class="nav-link">Tasks</a></li>
                </ul>
            </div>

            <div class="main">
                <router-view />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "variables";
    @import "~bootstrap/scss/bootstrap";
    @import "app";
</style>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState(['project']),
            isProjectLoaded() {
                return typeof this.project.id !== 'undefined';
            }
        }
    }
</script>
